import React from 'react';

import {PageHeader, StepProgressBar} from 'presentation/components';
import {useSteps} from 'presentation/pages/public/hooks';
import {translations} from 'presentation/translations-new';
import {useMediaQueries} from 'presentation/pages/private';
import {HeaderProps} from './types';

const {needHelp} = translations['pt-br'].publicFlow.forgotPassword;

function getCustomPadding(isDesktop: boolean, headerTitle: string) {
	if (isDesktop && headerTitle === needHelp) return '32px 16px 0px';
	if (isDesktop) return '32px 16px 16px';
	return '12px 12px 0px';
}

export function Header({
	headerTitle,
	headerSubtitle,
	totalSteps,
	stepType,
	showProgressBar,
	dataTagId,
}: HeaderProps) {
	const {currentStepState, handleBackStep, handleClose, handleCodeStep} = useSteps(stepType);
	const {isDesktop} = useMediaQueries();

	return (
		<PageHeader.Root
			dataTagId={dataTagId}
			customGap="8px"
			customPadding={getCustomPadding(isDesktop, headerTitle)}
			title={headerTitle}
			onClickBackButton={headerTitle === needHelp ? handleCodeStep : handleBackStep}
			showCloseButton={headerTitle !== needHelp}
			onClickCloseButton={handleClose}>
			{showProgressBar ? (
				<StepProgressBar currentStep={currentStepState} totalSteps={totalSteps} />
			) : null}

			<PageHeader.Subtitle>{headerSubtitle ?? ''}</PageHeader.Subtitle>
		</PageHeader.Root>
	);
}
